<template>
	<div>
		<div id="wrap">
			<div>
				<el-button type="primary" @click="handleAdd">添加</el-button>
			</div>

			<el-form :inline="true" class="from" ref="formQuery" :model="queryParams">
				<el-form-item label="时间">
					<el-date-picker
						v-model="queryParams.annual"
						type="year"
						value-format="yyyy"
						placeholder="请选择选择年度"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item class="item_btn">
					<el-button type="primary" @click="handleQuery">查询</el-button>
					<el-button type="primary" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<div class="flex flex-end"></div>

			<el-dialog
				title="动力管理"
				:visible.sync="centerDialogVisible"
				width="30%"
				center
			>
				<div>
					<el-form
						label-width="120px"
						:model="formData"
						:rules="rules"
						ref="formData"
					>
						<el-form-item v-if="!type" prop="projectId" label="选择项目：">
							<el-select v-model="formData.projectId" placeholder="设备类型">
								<el-option
									v-for="dict in projectList"
									:key="dict.id"
									:label="dict.projectName"
									:value="dict.id"
									placeholder="请选择"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="calculationTime" label="核算时间：">
							<el-date-picker
								:editable="false"
								value-format="yyyy-MM-dd"
								:picker-options="pickerOptions"
								v-model="formData.calculationTime"
								placeholder="请选择"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="动力明细：">
							<el-input v-model="formData.powerDetail"></el-input>
						</el-form-item>
						<el-form-item prop="adjustmentCoefficient" label="调整系数：">
							<el-input v-model="formData.adjustmentCoefficient"></el-input>
						</el-form-item>
						<el-form-item prop="researchEquipmentDegree" label="研发设备：">
							<el-input
								type="number"
								:min="1"
								v-model="formData.researchEquipmentDegree"
								@blur="totalAmountBlur"
								><template slot="append">度</template></el-input
							>
						</el-form-item>
						<el-form-item prop="assistEquipmentDegree" label="辅助设备：">
							<el-input
								type="number"
								:min="1"
								v-model="formData.assistEquipmentDegree"
								@blur="totalAmountBlur"
								><template slot="append">度</template></el-input
							>
						</el-form-item>
						<el-form-item prop="price" label="单价：">
							<el-input
								type="number"
								:min="1"
								v-model="formData.price"
								@blur="totalAmountBlur"
								><template slot="append">元/度</template></el-input
							>
						</el-form-item>
						<el-form-item prop="otherAmount" label="其他动力：">
							<el-input
								type="number"
								:min="1"
								v-model="formData.otherAmount"
								@blur="totalAmountBlur"
								><template slot="append">元</template></el-input
							>
						</el-form-item>
						<el-form-item prop="totalAmount" label="动力总金额：">
							<el-input v-model="formData.totalAmount" disabled></el-input>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">返回</el-button>
					<el-button type="primary" @click="classSubmitForm">保存</el-button>
				</span>
			</el-dialog>

			<el-table
				class="table"
				:data="datas"
				:header-cell-style="{ background: '#F5F7FA' }"
				v-loading="loading"
				:row-class-name="tableRowClassName"
			>
				<el-table-column
					label="核算时间"
					prop="calculationTime"
				></el-table-column>
				<el-table-column
					prop="adjustmentCoefficient"
					label="调整系数"
					width="140"
				>
				</el-table-column>
				<el-table-column
					prop="researchEquipmentDegree"
					label="研发设备电度数"
				></el-table-column>
				<el-table-column
					label="辅助设备电度数"
					prop="assistEquipmentDegree"
				></el-table-column>
				<el-table-column label="单价" prop="price"></el-table-column>
				<el-table-column
					label="其他动力金额"
					prop="otherAmount"
					width="160"
				></el-table-column>

				<el-table-column label="所属项目" prop="projectName"></el-table-column>
				<el-table-column
					label="更新时间"
					prop="updateTime"
					show-overflow-tooltip
				></el-table-column>

				<el-table-column label="操作" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							class="green"
							@click="handleUpdate(scope.row.id)"
							>编辑</el-button
						>
						<el-button
							type="text"
							size="small"
							class="red"
							@click="handleDelete(scope.row.id)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<div class="flex flex-end">
				<el-pagination
					class="pagination"
					background
					v-show="total > 0"
					:total="total"
					:current-page.sync="queryParams.pageNum"
					:page-size.sync="queryParams.pageSize"
					@current-change="getList"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import {
	projectManagementGet,
	powerManagementQueryAll,
	powerManagementQuery,
	powerManagementSave,
	powerManagementDelete
} from "../fixedAssets";
export default {
	props: {
		projectId: {
			type: String,
			default: ""
		},
		type: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			centerDialogVisible: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10
			},
			datas: [],
			total: 1,
			formData: {},
			rules: {
				calculationTime: [
					{ required: true, message: "请选择核算时间", trigger: "change" }
				]
			},
			amortizationTotal: "",
			projectList: [],
			// 遮罩层
			loading: true,
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			}
		};
	},
	created() {
		this.resetQuery();
	},
	methods: {
		totalAmountBlur() {
			if (
				this.formData.researchEquipmentDegree != null &&
				this.formData.assistEquipmentDegree != null &&
				this.formData.price != null &&
				this.formData.otherAmount != null
			) {
				this.$set(
					this.formData,
					"totalAmount",
					(Number(this.formData.researchEquipmentDegree) +
						Number(this.formData.assistEquipmentDegree)) *
						Number(this.formData.price) +
						Number(this.formData.otherAmount)
				);
			}
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 列表 */
		getList() {
			this.loading = true;
			powerManagementQueryAll(this.queryParams).then(res => {
				if (res.code == "00000") {
					this.datas = res.data.records;
					this.total = res.data.total;
				}
				this.loading = false;
			});
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 重置按钮操作 */
		resetQuery() {
			this.resetForm("formQuery");
			this.queryParams = {};
			if (this.type) {
				this.queryParams.projectId = this.projectId;
			}
			this.handleQuery();
		},
		// 表单重置
		reseForm() {
			this.formData = {};
			if (!this.type) {
				projectManagementGet().then(res => {
					this.projectList = res.data;
				});
			} else {
				this.formData.projectId = this.projectId;
			}
			this.resetForm("formData");
		},
		// 新增
		handleAdd() {
			this.reseForm();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.reseForm();
			powerManagementQuery(id).then(res => {
				this.formData = res.data;
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.$refs["formData"].validate(valid => {
				if (valid) {
					powerManagementSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.handleQuery();
							this.centerDialogVisible = false;
							this.msgSuccess(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			this.$confirm("是否确认删除动力?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return powerManagementDelete({ ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		}
	}
};
</script>
<style scoped>
.from {
	margin-top: 15px;
}
.item_btn {
	float: right;
}
</style>
